<template>
    <ComboboxPortal disabled>
        <ComboboxContent
            v-bind="forwarded"
            :auto-focus="false"
            :class="
                cn(
                    'ds-combobox-content',
                    // shadcn state control classes
                    'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 w-[--reka-combobox-trigger-width] bg-white',
                    props.class,
                )
            "
        >
            <slot />
        </ComboboxContent>
    </ComboboxPortal>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { ComboboxContentEmits, ComboboxContentProps } from 'reka-ui';
import { ComboboxContent, ComboboxPortal, useForwardPropsEmits } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = withDefaults(
    defineProps<
        ComboboxContentProps & {
            class?: HTMLAttributes['class'];
            autoFocus?: boolean;
        }
    >(),
    {
        position: 'popper',
        align: 'center',
        sideOffset: 4,
        autoFocus: false,
    },
);
const emits = defineEmits<ComboboxContentEmits>();

const delegatedProps = reactiveOmit(props, 'class', 'autoFocus');

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<style lang="scss">
.ds-combobox-content {
    @apply z-50 min-w-3 rounded-lg border border-ds-primary-200 bg-white shadow-popover outline-none;
    contain: layout;
}
</style>
